import { fetchWrapper } from '@/helpers/fetch-wrapper';
import { defineStore } from 'pinia';
import { useUIStore } from './ui.store';
import type { IUserConfig } from '@/helpers/types';
import { useAuthStore } from './auth.store';

const baseUrl = `/api/config`;

export const useConfigStore = defineStore({
    id: 'config',
    state: () => ({
        config: {} as IUserConfig,
        configLoaded: false,
    }),
    actions: {
        async getMyConfig() {
            if (!this.configLoaded) {
                const uiStore = useUIStore();
                uiStore.startLoading();
                return fetchWrapper.get(`${baseUrl}`)
                    .then(({ data }) => this.config = data)
                    .catch((error) => {
                        console.log(error);
                        uiStore.showMessage("error", error.message || "Erro ao recuperar a configuração.");
                    })
                    .finally(() => uiStore.stopLoading());
                this.configLoaded = true;
            }
            return this.config;
        },
        async updateConfig(id: number, body: any) {
            const uiStore = useUIStore();
            const authStore = useAuthStore();
            uiStore.startLoading();
            return fetchWrapper.put(`${baseUrl}/${id}`, body)
                .then(async () => {
                    await authStore.auth();
                    uiStore.showMessage("success", "Dados atualizados com sucesso!");
                })
                .catch((error) => {
                    console.error(error);
                    const errorMessage = error.message || "Erro ao atualizar configuração.";
                    uiStore.showMessage("error", errorMessage);
                })
                .finally(() => uiStore.stopLoading());
        },
    }
});
